import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import { DisplayStringTrans } from '@gamiphy/react-i18n';
import { useLoyaltyPageContext } from '../../context';
import { useIsSmallScreen } from '../../hooks';
import BenefitCard from './BenefitCard';

const BenefitsSection: React.FC = () => {
  const {
    isMobilePreview,
    images,
    enabledSections: {
      promoteCashbackIsEnabled,
      promoteWelcomeGiftIsEnabled,
    },
    colors: {
      promoteWelcomeGiftTextColor,
    },
    texts: {
      WelcomeGiftText,
      cashbackText,
    },
    welcomeGift,
    showWelcomeGiftBenefit,
    cashbackProgram: {
      cashbackPercentage,
    },
    isCashbackEnabled,
  } = useLoyaltyPageContext();
  const isMobile = useIsSmallScreen();

  const welcomeGiftImage = React.useMemo(() => {
    if (isMobile || isMobilePreview) {
      return images.welcomeGiftImage?.mobile?.url ?? images.welcomeGiftImage?.desktop?.url;
    }
    return images.welcomeGiftImage?.desktop?.url;
  }, [isMobilePreview, isMobile, images.welcomeGiftImage?.desktop?.url, images.welcomeGiftImage?.mobile?.url]);

  const cashbackImage = React.useMemo(() => {
    if (isMobile || isMobilePreview) {
      return images.cashbackImage?.mobile?.url ?? images.cashbackImage?.desktop?.url;
    }
    return images.cashbackImage?.desktop?.url;
  }, [isMobilePreview, isMobile, images.cashbackImage?.desktop?.url, images.cashbackImage?.mobile?.url]);

  return (
    <Container
      maxWidth={isMobile || isMobilePreview ? false : 'lg'}
      disableGutters={!(isMobile || isMobilePreview)}
      sx={{
        py: {
          xs: 3,
          sm: 5,
        },
      }}
    >
      <Box>
        <Grid container spacing={2}>
          {showWelcomeGiftBenefit && promoteWelcomeGiftIsEnabled && (
            <Grid size={{ xs: 12, md: isMobilePreview ? 12 : 6 }}>
              <BenefitCard
                isMobilePreview={isMobilePreview}
                image={welcomeGiftImage}
                TextColor={promoteWelcomeGiftTextColor}
                description={<DisplayStringTrans displayString={WelcomeGiftText} values={{ value: welcomeGift }} />}
              />
            </Grid>
          )}
          {
            promoteCashbackIsEnabled && isCashbackEnabled && (
              <Grid size={{ xs: 12, md: isMobilePreview ? 12 : 6 }}>
                <BenefitCard
                  isMobilePreview={isMobilePreview}
                  image={cashbackImage}
                  TextColor={promoteWelcomeGiftTextColor}
                  description={<DisplayStringTrans displayString={cashbackText} values={{ cashbackPercentage }} />}
                />
              </Grid>
            )
          }

        </Grid>
      </Box>
    </Container>
  );
};

export default BenefitsSection;
